// MobileSheets page localized text — mirrors forscoreText.js structure so the
// same section layout renders in whatever language the shopper is in.
var mobilesheetsText = {
  en: {
    digitalLibrary: 'DIGITAL LIBRARY',
    title: 'Real Books for MobileSheets',
    subtitle: 'Fully indexed MobileSheets files (.msf) — bookmarked by song title, ready for MobileSheets on Android, iOS & Windows.',
    indexedTitle: 'Every song, one tap away',
    findInstantly: 'Search by title. Jump to any chart in seconds.',
    desc: 'Every song in these Real Books has been individually pre-tagged so MobileSheets\' search finds it instantly on your Android tablet, iPad, or PC.',
    noMore: 'No more flipping through thousands of pages during a gig.',
    exclusiveNote: 'These are saved MobileSheets index files (.msf) — they work only in MobileSheets. To install, simply download the file and open it with MobileSheets. For iPad-only players who prefer forScore, see our /forscore page.',
    howItWorks: 'How it works',
    step1: '1. Download the file and open it with MobileSheets',
    step2: '2. Type the tune title — MobileSheets jumps to the exact page',
    step3: '3. Ready to play in under 2 seconds',
    perfectFor: 'Perfect for',
    pf1: 'Live gigs where song requests come in fast',
    pf2: 'Big band rehearsals',
    pf3: 'Jazz jam sessions',
    pf4: 'Practice at home',
    whyNeed: 'Why MobileSheets shoppers love these',
    wn1: 'Works on Android, iOS, Windows & macOS — one purchase, every device',
    wn2: 'Zero setup — the index and bookmarks are built into the file',
    wn3: 'Instant download after purchase',
    turnYour: 'Turn your tablet into the fastest fake book on the bandstand.',
    playMore: 'Play more. Search less.',
    bb: 'Trumpet / Tenor Sax', bbSub: 'Bb Volumes',
    eb: 'Alto Sax / Baritone', ebSub: 'Eb Volumes',
    bass: 'Trombone / Bass', bassSub: 'Bass Clef Volumes',
    c: 'Piano / Guitar', cSub: 'C Volumes',
    fake: 'Fake Books', fakeSub: 'Jazz, Movie, TV, Broadway and Beatles collections',
    android: 'Works on Android, iOS, Windows & macOS'
  },
  es: {
    digitalLibrary: 'BIBLIOTECA DIGITAL',
    title: 'Real Books para MobileSheets',
    subtitle: 'Archivos de MobileSheets (.msf) completamente indexados — marcados por título de canción, listos para MobileSheets en Android, iOS y Windows.',
    indexedTitle: 'Cada canción, a un toque',
    findInstantly: 'Busca por título. Salta a cualquier tema en segundos.',
    desc: 'Cada canción de estos Real Books ha sido pre-etiquetada individualmente para que la búsqueda de MobileSheets la encuentre al instante en tu tablet Android, iPad o PC.',
    noMore: 'Se acabó buscar entre miles de páginas durante un concierto.',
    exclusiveNote: 'Son archivos de índice guardados de MobileSheets (.msf) — solo funcionan en MobileSheets. Para instalarlos, descarga el archivo y ábrelo con MobileSheets. Si usas solo iPad y prefieres forScore, revisa nuestra sección /forscore.',
    howItWorks: 'Cómo funciona',
    step1: '1. Descarga el archivo y ábrelo con MobileSheets',
    step2: '2. Escribe el título — MobileSheets salta a la página exacta',
    step3: '3. Listo para tocar en menos de 2 segundos',
    perfectFor: 'Perfecto para',
    pf1: 'Conciertos con pedidos rápidos del público',
    pf2: 'Ensayos de big band',
    pf3: 'Jam sessions de jazz',
    pf4: 'Práctica en casa',
    whyNeed: 'Por qué a los usuarios de MobileSheets les encanta',
    wn1: 'Funciona en Android, iOS, Windows y macOS — una compra, todos los dispositivos',
    wn2: 'Sin configuración — el índice y los marcadores vienen dentro del archivo',
    wn3: 'Descarga instantánea al pagar',
    turnYour: 'Convierte tu tablet en el fake book más rápido del escenario.',
    playMore: 'Toca más. Busca menos.',
    bb: 'Trompeta / Saxo Tenor', bbSub: 'Volumenes en Sib',
    eb: 'Saxo Alto / Baritono', ebSub: 'Volumenes en Mib',
    bass: 'Trombon / Bajo', bassSub: 'Volumenes en Clave de Fa',
    c: 'Piano / Guitarra', cSub: 'Volumenes en Do',
    fake: 'Fake Books', fakeSub: 'Jazz, Cine, TV, Broadway y Beatles',
    android: 'Funciona en Android, iOS, Windows y macOS'
  },
  ja: {
    digitalLibrary: 'デジタル・ライブラリ',
    title: 'MobileSheets用リアルブック',
    subtitle: '完全にインデックス化された MobileSheetsファイル（.msf）— 曲名でブックマーク済み、Android・iOS・Windowsの MobileSheetsですぐに使えます。',
    indexedTitle: 'すべての曲がワンタップで',
    findInstantly: 'タイトルで検索。数秒で任意の譜面へ。',
    desc: 'これらのリアルブックの全曲が個別にプリタグ付けされており、Androidタブレット・iPad・PCの MobileSheetsで即座に検索できます。',
    noMore: 'ライブ中に何千ページもめくる必要はもうありません。',
    exclusiveNote: 'これらは MobileSheetsの保存済みインデックスファイル（.msf）で、MobileSheets専用です。インストールはダウンロードして MobileSheetsで開くだけです。iPadで forScoreをお使いの方は /forscoreページをご覧ください。',
    howItWorks: '使い方',
    step1: '1. ファイルをダウンロードして MobileSheetsで開く',
    step2: '2. 曲名を入力 — MobileSheetsが正確なページにジャンプ',
    step3: '3. 2秒以内に演奏開始',
    perfectFor: 'こんな時に最適',
    pf1: 'リクエストが飛び交うライブ',
    pf2: 'ビッグバンドのリハーサル',
    pf3: 'ジャズのジャムセッション',
    pf4: '自宅練習',
    whyNeed: 'MobileSheetsユーザーが愛用する理由',
    wn1: 'Android・iOS・Windows・macOSに対応 — 一度の購入で全デバイス',
    wn2: 'セットアップ不要 — インデックスとブックマークはファイルに内蔵',
    wn3: '購入後すぐにダウンロード',
    turnYour: 'あなたのタブレットを、ステージ最速のフェイクブックに。',
    playMore: 'もっと演奏、もっと少ない検索。',
    bb: 'トランペット / テナーサックス', bbSub: 'Bb版',
    eb: 'アルトサックス / バリトン', ebSub: 'Eb版',
    bass: 'トロンボーン / ベース', bassSub: 'ヘ音記号版',
    c: 'ピアノ / ギター', cSub: 'C版',
    fake: 'フェイクブック', fakeSub: 'ジャズ、映画、TV、ブロードウェイ、ビートルズ',
    android: 'Android・iOS・Windows・macOS対応'
  },
  de: {
    digitalLibrary: 'DIGITALE BIBLIOTHEK',
    title: 'Real Books für MobileSheets',
    subtitle: 'Vollständig indexierte MobileSheets-Dateien (.msf) — nach Songtitel markiert, bereit für MobileSheets auf Android, iOS und Windows.',
    indexedTitle: 'Jeder Song, einen Tap entfernt',
    findInstantly: 'Nach Titel suchen. In Sekunden zu jedem Stück springen.',
    desc: 'Jeder Song in diesen Real Books wurde einzeln vor-getaggt, sodass die MobileSheets-Suche ihn sofort auf Android-Tablet, iPad oder PC findet.',
    noMore: 'Kein Durchblättern von Tausenden Seiten mehr während eines Gigs.',
    exclusiveNote: 'Dies sind gespeicherte MobileSheets-Indexdateien (.msf) — sie funktionieren nur in MobileSheets. Zum Installieren einfach die Datei herunterladen und mit MobileSheets öffnen. Für iPad-Spieler mit forScore siehe /forscore.',
    howItWorks: 'So funktioniert es',
    step1: '1. Datei herunterladen und mit MobileSheets öffnen',
    step2: '2. Songtitel eingeben — MobileSheets springt zur exakten Seite',
    step3: '3. In unter 2 Sekunden spielbereit',
    perfectFor: 'Perfekt für',
    pf1: 'Live-Gigs mit schnellen Wünschen',
    pf2: 'Big-Band-Proben',
    pf3: 'Jazz-Jamsessions',
    pf4: 'Zuhause üben',
    whyNeed: 'Warum MobileSheets-Nutzer sie lieben',
    wn1: 'Funktioniert auf Android, iOS, Windows und macOS — ein Kauf, alle Geräte',
    wn2: 'Kein Setup — Index und Lesezeichen sind in der Datei enthalten',
    wn3: 'Sofortiger Download nach dem Kauf',
    turnYour: 'Machen Sie Ihr Tablet zum schnellsten Fake-Book der Bühne.',
    playMore: 'Mehr spielen. Weniger suchen.',
    bb: 'Trompete / Tenorsaxophon', bbSub: 'Bb-Ausgaben',
    eb: 'Altsaxophon / Bariton', ebSub: 'Eb-Ausgaben',
    bass: 'Posaune / Bass', bassSub: 'Bassschlussel-Ausgaben',
    c: 'Klavier / Gitarre', cSub: 'C-Ausgaben',
    fake: 'Fake Books', fakeSub: 'Jazz, Film, TV, Broadway und Beatles',
    android: 'Funktioniert auf Android, iOS, Windows und macOS'
  },
  fr: {
    digitalLibrary: 'BIBLIOTHÈQUE NUMÉRIQUE',
    title: 'Real Books pour MobileSheets',
    subtitle: 'Fichiers MobileSheets (.msf) entièrement indexés — signets par titre de chanson, prêts pour MobileSheets sur Android, iOS et Windows.',
    indexedTitle: 'Chaque morceau à portée d\'un tap',
    findInstantly: 'Recherche par titre. Sautez à n\'importe quel morceau en quelques secondes.',
    desc: 'Chaque morceau de ces Real Books a été pré-étiqueté individuellement — la recherche MobileSheets le trouve instantanément sur votre tablette Android, iPad ou PC.',
    noMore: 'Fini de feuilleter des milliers de pages pendant un concert.',
    exclusiveNote: 'Ce sont des fichiers d\'index MobileSheets enregistrés (.msf) — ils fonctionnent uniquement dans MobileSheets. Pour installer, téléchargez le fichier et ouvrez-le avec MobileSheets. Utilisateurs iPad + forScore : voir /forscore.',
    howItWorks: 'Comment ça marche',
    step1: '1. Téléchargez le fichier et ouvrez-le avec MobileSheets',
    step2: '2. Tapez le titre — MobileSheets saute à la page exacte',
    step3: '3. Prêt à jouer en moins de 2 secondes',
    perfectFor: 'Parfait pour',
    pf1: 'Concerts avec demandes rapides',
    pf2: 'Répétitions de big band',
    pf3: 'Jam sessions de jazz',
    pf4: 'Répétitions à la maison',
    whyNeed: 'Pourquoi les utilisateurs MobileSheets adorent',
    wn1: 'Fonctionne sur Android, iOS, Windows et macOS — un achat, tous vos appareils',
    wn2: 'Aucune configuration — l\'index et les signets sont dans le fichier',
    wn3: 'Téléchargement immédiat après achat',
    turnYour: 'Transformez votre tablette en le fake book le plus rapide de la scène.',
    playMore: 'Jouez plus. Cherchez moins.',
    bb: 'Trompette / Saxophone Tenor', bbSub: 'Volumes en Sib',
    eb: 'Saxophone Alto / Baryton', ebSub: 'Volumes en Mib',
    bass: 'Trombone / Basse', bassSub: 'Volumes en Cle de Fa',
    c: 'Piano / Guitare', cSub: 'Volumes en Do',
    fake: 'Fake Books', fakeSub: 'Jazz, Cinéma, TV, Broadway et Beatles',
    android: 'Fonctionne sur Android, iOS, Windows et macOS'
  },
  it: {
    digitalLibrary: 'LIBRERIA DIGITALE',
    title: 'Real Books per MobileSheets',
    subtitle: 'File MobileSheets (.msf) completamente indicizzati — segnalibri per titolo, pronti per MobileSheets su Android, iOS e Windows.',
    indexedTitle: 'Ogni brano a un tocco di distanza',
    findInstantly: 'Cerca per titolo. Salta a qualsiasi spartito in pochi secondi.',
    desc: 'Ogni brano di questi Real Book è stato pre-taggato singolarmente — la ricerca di MobileSheets lo trova all\'istante sul tuo tablet Android, iPad o PC.',
    noMore: 'Basta sfogliare migliaia di pagine durante un concerto.',
    exclusiveNote: 'Sono file di indice salvati di MobileSheets (.msf) — funzionano solo in MobileSheets. Per installarli, scarica il file e aprilo con MobileSheets. Se usi solo iPad con forScore, consulta la nostra pagina /forscore.',
    howItWorks: 'Come funziona',
    step1: '1. Scarica il file e aprilo con MobileSheets',
    step2: '2. Digita il titolo — MobileSheets salta alla pagina esatta',
    step3: '3. Pronto a suonare in meno di 2 secondi',
    perfectFor: 'Perfetto per',
    pf1: 'Concerti dal vivo con richieste rapide',
    pf2: 'Prove di big band',
    pf3: 'Jam session jazz',
    pf4: 'Studio a casa',
    whyNeed: 'Perché gli utenti MobileSheets lo amano',
    wn1: 'Funziona su Android, iOS, Windows e macOS — un acquisto, tutti i dispositivi',
    wn2: 'Nessuna configurazione — indice e segnalibri sono dentro il file',
    wn3: 'Download istantaneo dopo l\'acquisto',
    turnYour: 'Trasforma il tuo tablet nel fake book più veloce del palco.',
    playMore: 'Suona di più. Cerca di meno.',
    bb: 'Tromba / Sax Tenore', bbSub: 'Volumi in Sib',
    eb: 'Sax Alto / Baritono', ebSub: 'Volumi in Mib',
    bass: 'Trombone / Basso', bassSub: 'Volumi in Chiave di Basso',
    c: 'Pianoforte / Chitarra', cSub: 'Volumi in Do',
    fake: 'Fake Books', fakeSub: 'Jazz, Cinema, TV, Broadway e Beatles',
    android: 'Funziona su Android, iOS, Windows e macOS'
  }
};

export default mobilesheetsText;
